import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Y si no sé nada de IA?',
    a: 'Si sabes enviar un mensaje de texto, puedes usar este sistema. Todo está explicado paso a paso.'
  }, {
    q: '¿Y si no tengo seguidores?',
    a: 'No necesitas seguidores. Te enseñamos a atraer personas que ya buscan lo que vendes.'
  }, {
    q: '¿Y si solo tengo iPhone/Android?',
    a: 'Funciona 100% desde cualquier celular. No necesitas computadora.'
  }, {
    q: '¿Cuánto tiempo necesito al día?',
    a: 'Con 1-2 horas al día puedes avanzar. El sistema está diseñado para mamás ocupadas.'
  }, {
    q: '¿Esto sirve si trabajo o cuido niños?',
    a: 'Absolutamente. Fue creado pensando en mamás que no tienen tiempo libre. Puedes avanzar en ratos libres.'
  }, {
    q: '¿Necesito invertir en publicidad?',
    a: 'No. Te enseñamos métodos orgánicos gratuitos con Instagram y WhatsApp.'
  }, {
    q: '¿Cómo recibo el producto?',
    a: 'Inmediatamente después del pago recibes acceso digital. Lo descargas en tu celular y empiezas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-white py-12 md:py-24 px-4" data-id="element-64">
      <div className="max-w-3xl mx-auto" data-id="element-65">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 md:mb-16" data-id="element-66">
          <span className="text-primary font-bold uppercase tracking-wider text-sm mb-2 block" data-id="element-67">
            Preguntas Frecuentes
          </span>
          <h2 className="text-3xl md:text-4xl text-dark font-display font-extrabold tracking-headline" data-id="element-68">
            Resolvemos tus dudas
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-69">
          {faqs.map((faq, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white rounded-[20px] border border-stone-200 overflow-hidden shadow-sm" data-id="element-70">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-71">
                <span className="text-dark font-display font-bold text-lg pr-4" data-id="element-72">
                  {faq.q}
                </span>
                <div className={`flex-shrink-0 w-8 h-8 rounded-full bg-white flex items-center justify-center shadow-sm transition-transform duration-300 ${openIndex === idx ? 'rotate-180 bg-primary text-white' : 'text-primary'}`} data-id="element-73">
                  <ChevronDown className="w-5 h-5" data-id="element-74" />
                </div>
              </button>
              <AnimatePresence data-id="element-75">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} className="overflow-hidden" data-id="element-76">
                    <div className="p-6 pt-0 text-body leading-relaxed text-lg border-t border-border/50 mt-2" data-id="element-77">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}